import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Grid, Badge, Tooltip, Typography, Drawer, FormControl } from "@material-ui/core";
import axios from 'axios';
// import Link from '@material-ui/core/Link';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DocIcon from '../../icons/DocIcon';
import BasketIcon from '../../icons/BasketIcon';
import ClearIcon from '../../icons/ClearIcon';
import RoundTableIcon from '../../icons/RoundTableIcon';
import Button from '@material-ui/core/Button';
import BasketAskCFT from "./BasketAskCFT";
// import AddAppsFromXLSX from "./AddAppsFromXLSX";
import ChangeViewArray from '../ChangeViewArray';
import AllAppsTable from "../Applications/AllAppsTable";
import AllAppsTile from "../Applications/AllAppsTile";
import AllAppsTbl from "../Applications/AllAppsTbl";
import AllProdsTable from "../Products/AllProdsTable";
import AllProdsTile from "../Products/AllProdsTile";
import AllProdsTbl from "../Products/AllProdsTbl";
import CloudServiceLineCard from "../Cloud/CloudServiceLineCard";
import CloudServiceCard from "../Cloud/CloudServiceCard";
import translate from '../../other/translate.json';
import PrimaryButtonBasketAsk from '../PrimaryButtonBasketAsk';
import PrimaryButtonBasketBuy from '../PrimaryButtonBasketBuy';
import PrimaryButton from '../PrimaryButton';
import AddAppIcon from '../../icons/AddAppIcon';
import Pagination from '@material-ui/lab/Pagination';
import Snackbar from '@material-ui/core/Snackbar';
import SecondaryButton2 from "../SecondaryButton2";
import Chip from '@material-ui/core/Chip';
import clsx from "clsx";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Avatar from '@material-ui/core/Avatar';
import config from '../../other/config';
import utils from '../../other/utils';
import FilterIcon from '../../icons/FilterIcon';
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import KloBanksChoose from '../KloBanksChoose';
import ChevronIcon from "../../icons/ChevronIcon";
import { ShoppingBasket } from "@material-ui/icons"
import ChipArrayRed from '../ChipArrayRed';
import SubFilterList from '../SubFilterListVers3';
import SkeletonCardTable from "../Skeleton/SkeletonCardTable";
import SkeletonCardTile from "../Skeleton/SkeletonCardTile";
import CustomSelect from '../CustomSelect';

import ExpandLessIcon from "@material-ui/icons/ExpandLess";
//import { render } from "@testing-library/react";
const { compareApps, getItemFromStorage } = utils
let moment = require('moment');
require("moment/min/locales.min");
//const availableStatuses = ["Куплено (используется)", "Куплено (не используется)", "Не куплено (используется)", "Не куплено (не используется)", "В процессе оформления покупки (используется)", "В процессе оформления покупки (не используется)", "Нет данных"]
const { serverAPI } = config;
const StyledBadge = withStyles((theme) => ({
  badge: {
    top: 32,
    right: -6,
    height: 10,
    width: 10,
    borderRadius: 5,
    backgroundColor: '#EB505E'
  },
}))(Badge);

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);
export default function BasketContent(props) {
  let [resetState, _resetState] = useState(true)
  let [addedDependencies, _addedDependencies] = useState(false)
  let { basketChips, prodBasketChips, menu } = props
  const kloUser = props.kloUser;
  const { currentServerPart, user, currentBank } = kloUser;
  const availableStatuses = user && user.IS_CFT === '1' ? ["Куплено (используется)", "Куплено (не используется)", "Не куплено (используется)", "Не куплено (не используется)", "В процессе оформления покупки (используется)", "В процессе оформления покупки (не используется)", "Нет данных"] : ["Куплено", /*"Не куплено",*/"Не куплено (используется)", "Не куплено (не используется)", "В процессе оформления покупки (используется)", "В процессе оформления покупки (не используется)", "Нет данных"]

  // const [prodBasket, _prodBasket] = useState(JSON.parse(localStorage.getItem('cartProd')) || [])
  let cartApps = getItemFromStorage('cartApp')

  const [appBasket, _appBasket] = useState(cartApps)
  const [cloudBasket, _cloudBasket] = useState(JSON.parse(localStorage.getItem('cartCloud')) || []);
  const [pageTbl, setPageTbl] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [arrayTag, setArrayTags] = useState(JSON.parse(localStorage.getItem('AppsArrayTag')) || []);
  const [statusFilter, _statusFilter] = useState(false);
  const [filterStatusKlo, _filterStatusKlo] = useState([]);
  const [sortingSelectVal, _sortingSelectVal] = useState('codeAsvulSortA');
  const [alternatives, _alternatives] = useState();

  let [view, _view] = useState(localStorage.getItem('view') || 'table')
  let language = localStorage.getItem('language') || 'Ru'
  window.addEventListener('storage', function (e) {
    if (e.key === 'cartProd' || e.key === 'cartApp' || e.key === 'cartCloud') {

      //_resetState(!resetState)
      window.location.reload()
    }
  });

  const setArrayTag = (arr) => {
    setPage(1)
    setArrayTags(arr)
    localStorage.setItem('AppsArrayTag', JSON.stringify(arr))
  }

  function clearChips() {
    setPage(1)
    setArrayTags([])
  }

  function setView(view) {
    _view(view)
    localStorage.setItem('view', view)
  }

  function setBasketCloud(apps, IDCloud) {
    let _appBasket_ = JSON.parse(localStorage.getItem('cartApp')) || []
    if (cloudBasket.some((element) => element === IDCloud) === true) {
      _cloudBasket(cloudBasket.filter(el_ => el_ !== IDCloud))
      let arr_ = []
      _appBasket_.forEach(el => {
        if (apps.join('#').includes(el)) { } else {
          arr_.push(el)
        }
      })
      localStorage.setItem('cartCloud', JSON.stringify(cloudBasket.filter(el_ => el_ !== IDCloud)))
      _appBasket(arr_)
      localStorage.setItem('cartApp', JSON.stringify(arr_))
    }
    _resetState(!resetState)
  }

  let [first, setFirts] = React.useState(false);
  const classes = useStyles();
  const LANG = language === 'Ru' ? 'Ru' : 'Eng'
  const [notDeleteFromBasketArr, _notDeleteFromBasketArr] = useState([])
  const [notDeleteFromBasketArrCloud, _notDeleteFromBasketArrCloud] = useState([])
  const [notDeleteFromBasketArrN, _notDeleteFromBasketArrN] = useState([])
  const [notDeleteFromBasketArrR, _notDeleteFromBasketArrR] = useState([])
  const [appBasketRender, setAppBasketRender] = useState([])
  const [prodBasketRender, setProdBasketRender] = useState([])
  const [cloudBasketRender, setCloudBasketRender] = useState([])
  const [valueBasketTab, setValueBasketTab] = React.useState(0);
  const [stateAsk, setStateAsk] = React.useState(false);
  const [askCFT, setAskCFT] = useState(false);
  const [addXLSX, setAddXLSX] = useState(false);
  const [page, setPage] = React.useState(1);
  const [pageProd, setPageProd] = React.useState(1);
  const [pageCloud, setPageCloud] = React.useState(1);
  const [systems, setSystems] = useState([]);
  const [sortSystems, setSortSystems] = useState([]);
  const [currentSystems, _currentSystems] = useState([]);
  const [snackbarInfo, _snackbarInfo] = React.useState([false, null]);
  const [openSnackbar, _openSnackbar] = React.useState([false, null]);
  const [loading, _loading] = useState(false);
  const [loadingKloStatuses, _loadingKloStatuses] = useState(false);

  function changePage(event, value) {  // никак не пойму что есть value если мы его не передаём codeerr
    setPage(value);
    window.scrollTo(0, 0);
  };

  function changePageProd(event, value) {  // никак не пойму что есть value если мы его не передаём codeerr
    setPageProd(value);
    window.scrollTo(0, 0);
  };

  function changePageCloud(event, value) {  // никак не пойму что есть value если мы его не передаём codeerr
    setPageCloud(value);
    window.scrollTo(0, 0);
  };

  // const [visibledIndexBlock, setVisibledIndexBlock] = useState([0,1,2,3])
  function changeBasketTab(event, newValue) { // никак не пойму что есть value если мы его не передаём codeerr
    setValueBasketTab(newValue);
  };

  function handleStrockList(index) {// никак не пойму что есть value если мы его не передаём codeerr
    setView(index)
  };

  const [sumApp, _sumApp] = useState(0);
  const [sumAppCFT, _sumAppCFT] = useState(0);
  const [sumAppMS, _sumAppMS] = useState(0);

  const [sumAppN, _sumAppN] = useState(0); // раньше было - сейчас нет codeerr
  const [sumAppR, _sumAppR] = useState(0);// раньше было - сейчас нет codeerr
  const [sumN, _sumN] = useState(0); // раньше было - сейчас нет codeerr
  const [sumR, _sumR] = useState(0);// раньше было - сейчас нет codeerr
  const [sumProdN, _sumProdN] = useState(0);// раньше было - сейчас нет codeerr
  const [sumProdR, _sumProdR] = useState(0);// раньше было - сейчас нет codeerr
  const [expAccordion, _expAccordion] = React.useState(false);
  const [kloStatuses, _kloStatuses] = useState({});

  moment.locale(`${LANG.toLowerCase()}`);

  function loadwithdependencies(load) {
    if (load === true) {
      handleClose()
      dataToExcel(true)
    }
  }

  function closeSnackbar(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    _snackbarInfo([false, null]);
  };

  function uniqueArr(arr) {
    let result = [];

    for (let str of arr) {
      if (!result.includes(str)) {
        result.push(str);
      }
    }

    return result;
  }

  async function addDependency(load) {
    let basketApps = props.userCollection.appBasket;//JSON.parse(localStorage.getItem('cartApp')) || [];
    let appsInProducts = props.userCollection.appCartInProduct;
    //userCollection.
    let apps = [];

    const getDependency = await axios.post(`${serverAPI}/dependency`, { codeasvul: basketApps.concat(appsInProducts) });

    if (getDependency && getDependency.data) {
      getDependency.data.map(el => {
        if (!basketApps.includes(el.ID) && !appsInProducts.includes(el.ID)) {
          // console.log('el.ID', el.ID)
          apps.push(el.ID)
          // return el.ID
        }
      })

      //localStorage.setItem('cartApp', JSON.stringify(basketApps.concat(apps)))
      props.saveCollection(basketApps.concat(apps), 'app', 'cart', undefined, true)

      //  _appBasket(appBasket.concat(getDependency.data.map(el => {
      //          if (el.ID !== basketChips.includes(el.ID)) return el.ID
      //  })

      if (apps.length > 0) {
        handleClose()
        _snackbarInfo([true, translate.Words[`AddtoCartApps_${language}`] + ": " + (apps.length)])
      } else if (apps.length === 0) {
        handleClose()
        _snackbarInfo([true, translate.Words[`NoDependentApps_${language}`]])
      } else {
        handleClose()
        _snackbarInfo([true, translate.Words[`ErrDependentApps_${language}`]])
      }

      if (load === true) {
        // setTimeout(() => {
        loadwithdependencies(load)
        // }, 3000);
      }

      _addedDependencies(true)
      _resetState(!resetState)
    }
  }

  // const setAppBasket = (prod) => {
  //   if (basketChips.some((element) => element === prod.ID) === true) {
  //     _appBasket(basketChips.filter(el_ => el_ !== prod.ID))
  //     let r = JSON.parse(localStorage.getItem('cartApp')) || []
  //     localStorage.setItem('cartApp', JSON.stringify(r.filter(el_ => el_ !== prod.ID)))
  //   } else {
  //     _appBasket(basketChips.concat(prod.ID))
  //     let r = JSON.parse(localStorage.getItem('cartApp')) || []
  //     localStorage.setItem('cartApp', JSON.stringify(r.concat(prod.ID)))
  //   }
  // }

  const handleClick = () => {
    if ((appBasket && appBasket.length !== 0) || appBasketRender.length > 0 || prodBasketRender.length > 0 || cloudBasketRender.length > 0) {
      props.handleCloseCookieSnackbar()
      _openSnackbar([true, 'clear']);
    }
  };

  const handleClickLoad = () => {
    if ((appBasket && appBasket.length !== 0) || appBasketRender.length > 0) {
      props.handleCloseCookieSnackbar()
      _openSnackbar([true, 'dependencies']);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    _openSnackbar([false, null]);
  };

  useEffect(() => {
    if (first === false) {
      setFirts(true)
    }
  }, [first])

  // useEffect(() => {
  //   view === 'tile' ?
  //     history.push({ search: history.location.search.replace('?view=table', '?view=tile') }) :
  //     history.push({ search: history.location.search.replace('?view=tile', '?view=table') })
  // }, [view]);

  useEffect(() => {
    let appsInProducts = [];
    let apps_ = getItemFromStorage('cartAppInProduct');
    apps_.map(el => appsInProducts = appsInProducts.concat(el.apps))
    const appBasketA = getItemFromStorage('cartApp').concat(appsInProducts)

    if (appBasketA && appBasketA.length > 0) {
      let didCancel = false;
      async function fetchData() {
        _loading(true);
        const Apps = await axios.post(`${serverAPI}/apps?inCu=${props.userCollection.inCu}`,
          {
            apps: appBasketA.join(','),
            lang: language
          })
        if (!didCancel) {
          if (Apps && Apps.data) {
            if (sortingSelectVal.at(-1) === 'A') {
              if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
                setAppBasketRender(Apps.data.sort(compareApps))
              } else {
                setAppBasketRender(Apps.data.sort((a, b) => a[sortingSelectVal.slice(0, -1)] < b[sortingSelectVal.slice(0, -1)] ? 1 : -1))
              }
            } else {
              if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
                setAppBasketRender(Apps.data.sort(compareApps).reverse())
              } else {
                setAppBasketRender(Apps.data.sort((a, b) => a[sortingSelectVal.slice(0, -1)] > b[sortingSelectVal.slice(0, -1)] ? 1 : -1))
              }
            }

            // setAppBasketRender(Apps.data.sort(compareApps))
            let appSystems = [];
            let currs = []
            Apps.data.map((app) => {
              if (!appSystems.includes(app.Title_catalog)) {
                appSystems.push(app.Title_catalog)
              }
              if (app.Currency !== 2) {
                currs.push(app.Currency)
              }
            })


            if (appSystems.length > 0) {
              setSystems(appSystems)
            }
          } else {
            setAppBasketRender([])
          }
          _loading(false);
          props.userCollection.showTestId()
        }
      }

      fetchData();
      fetchAnalogsData(appBasketA);

      return () => {
        didCancel = true;
      };
    } else {
      setAppBasketRender([])
    }
  }, [resetState, language, sortingSelectVal]);

  async function fetchAnalogsData(applist) {
    let allApps = applist ? applist : appBasket;

    const dataAppAnalogs = await axios.post(`${serverAPI}/appAnalogs`, { appID: allApps.toString() }).then(res => {
      if (res.status === 200) {
        _alternatives(res.data.getData)
      } else {
        console.error('appAlternatives', res);
      }
    })
  }

  useEffect(() => {
    //let sortSystems = menu.filter(elem => elem.ID_Category === 3).map(elem => elem.Title).filter(elem => systems.includes(elem));
    let menuSystems = menu.filter(elem => elem.ID_Category === 3).map(elem => elem.Title)
    setSortSystems(systems.sort((a, b) => { let positionA = menuSystems.indexOf(a) === -1 ? 1000 : menuSystems.indexOf(a); let positionB = menuSystems.indexOf(b) === -1 ? 1000 : menuSystems.indexOf(b); return positionA - positionB }))
  }, [menu, systems]);

  // useEffect(() => {
  //   let cloudBasketNew = JSON.parse(localStorage.getItem('cartCloud')) || []
  //   if (cloudBasketNew && cloudBasketNew.length > 0) {
  //     let didCancel = false;
  //     async function fetchData() {
  //       const Apps = await axios.get(`${serverAPI}/cloudid/${cloudBasketNew.join(',')}/${language}`)
  //       const infoAppsForCloud = await axios.get(`${serverAPI}/clouds/${cloudBasketNew.join(',')}/${language}`)
  //       if (!didCancel) {
  //         if (Apps && Apps.data) {
  //           setCloudBasketRender(Apps.data)
  //           _notDeleteFromBasketArrCloud(infoAppsForCloud['data'].join(','))
  //         } else {
  //           setCloudBasketRender([])
  //         }
  //       }
  //     }

  //     fetchData();

  //     return () => {
  //       didCancel = true;
  //     };
  //   } else {
  //     setCloudBasketRender([])
  //   }
  // }, [cloudBasket, resetState, language]);

  useEffect(() => {
    let didCancel = false;
    async function fetchData() {
      const filteredApps = (apps) => {
        return currentSystems.length === 0 ? apps.filter(el => el.url_catalog === "cftbank") : apps.filter(elem => currentSystems.includes(elem.Title_catalog) && elem.url_catalog === "cftbank")
      }
      let apps = filteredApps(appBasketRender).filter((elem, index) => { if (view === 'tbl') { return true } else { return index < page * 24 && index >= (page - 1) * 24 } })
      if (apps.length > 0) {
        //view !== 'tbl'
        //Левобережка = 20343046
        _loadingKloStatuses(true);
        const statuses = await props.getKloStatuses(apps.map(el => el.codeasvul).join(','))
        _kloStatuses(statuses)
        const allStatuses = await props.getKloStatuses(filteredApps(appBasketRender).map(el => el.codeasvul).join(','))
        _kloStatuses(allStatuses)
        _loadingKloStatuses(false);

        /*await axios.post(`${utils.getKLOLink()}/get_lk_apps?month=${utils.getKLOMonth()}&bank=${kloUser.currentServerPart}`, 

        const statuses = await axios.post(`${utils.getKLOLink()}/get_lk_apps?month=${utils.getKLOMonth()}&bank=${kloUser.currentServerPart}`,
          {
            apps: apps.map(el => el.codeasvul).join(',')
          },
          {
            withCredentials: true,
            headers: {
              "Access-Control-Allow-Origin": "https://catalog.cft.ru/",
              'Cache-Control': 'cache',
              'Pragma': 'cache',
              'Expires': '0',
            }
          });

        if (statuses && statuses.data && Array.isArray(statuses.data.items)) {
          let statusObj = {}
          statuses.data.items.map(item => {
            item.OPTIONS.map(app => {
              let status = ''
              if (app.STATUS === "1") {
                status = app.STATUS_NAME
              } else if (app.DOGOVOR_VALUE === "КУПЛЕНО") {
                status = kloUser && kloUser.user && kloUser.user.IS_BANK === '0' ? [app.DOGOVOR_VALUE, `(${app.USAGE})`] : app.DOGOVOR_VALUE;
              } else if (app.DOGOVOR_VALUE === "НЕ КУПЛЕНО") {
                status = [app.DOGOVOR_VALUE, `(${app.USAGE})`]//`${app.DOGOVOR_VALUE} (${app.USAGE})`
              }
              statusObj[app.CODE] = status
            })

            console.log(kloUser.user)
          })
          //console.log(statusObj, kloStatuses)
          _kloStatuses(statusObj)
        }*/
      }
      let appCurrency = appBasketRender.filter(el => el.Currency !== 2 && el.isModernSystems !== 1).map(el => el.Currency);
      // console.log(appCurrency)
      if (appCurrency.includes(0)) {
        props.userCollection._CatalogCu('1')
      } else if (appCurrency.includes(1)) {
        props.userCollection._CatalogCu('0')
      } else {
        props.userCollection._CatalogCu(undefined)
      }
    }
    if (!didCancel) {
      fetchData();
    }
    return () => {
      didCancel = true;
    };
  }, [appBasketRender/*,page*/, currentBank]);

  const removeApp = (app) => {
    if (app.isModernSystems === 1) return // Удалять Приложения СС нельзя по клику на приложение СС, только через зависимое приложение !!!
    let removeArray = [];
    const appBasketNew = JSON.parse(localStorage.getItem('cartApp') || [])
    let modernSystemsApp = appBasketRender.filter(elem => elem.isModernSystems === 1)
    if (modernSystemsApp.length > 0) {
      modernSystemsApp.map(msApp => {
        let dependencies = msApp.dependedApps.split(';').filter(elem => elem !== msApp.codeasvul)

        if (dependencies.length === 1 && dependencies.includes(app.codeasvul)) {
          removeArray.push(msApp.ID)
        } else if (dependencies.includes(app.codeasvul)) {

          let anotherDependedApp = dependencies.filter(elem => elem !== app.codeasvul)
          // console.log(anotherDependedApp, appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0)
          if (appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0) {
            removeArray.push(msApp.ID)
          }
        }
      })
    }
    removeArray.push(app.ID)
    // console.log(modernSystemsApp)

    if (appBasketNew.some((element) => element === app.ID) === true) {

      if (currentSystems.length === 1 && app.Title_catalog === currentSystems[0] && appBasketRender.filter(elem => elem.Title_catalog === currentSystems[0]).length === 1) {
        _currentSystems([]);
      }
      localStorage.setItem('cartApp', JSON.stringify(appBasketNew.filter(el_ => !removeArray.includes(el_))))
    }
    //_addedDependencies(false)
    setAppBasketRender(appBasketRender.filter(elem => !removeArray.includes(elem.ID)))

    //_resetState(!resetState)
  }

  const setAppBasket = (prod) => {
    if (appBasket.some((element) => element === prod.ID) === true) {
      _appBasket(appBasket.filter(el_ => el_ !== prod.ID))
      let r = JSON.parse(localStorage.getItem('cartApp')) || []
      localStorage.setItem('cartApp', JSON.stringify(r.filter(el_ => el_ !== prod.ID)))
    } else {
      _appBasket(appBasket.concat(prod.ID))
      let r = JSON.parse(localStorage.getItem('cartApp')) || []
      localStorage.setItem('cartApp', JSON.stringify(r.concat(prod.ID)))
    }
    _addedDependencies(false)
    _resetState(!resetState)
  }

  /** Продукты ++++++++ начало */
  const setAppProdBasket = (prod) => { //TODO appBasket вынести в localstorage
    const prodBasketNew = JSON.parse(localStorage.getItem('cartProd')) || []
    const appBasketNew = getItemFromStorage('cartApp')
    if (prodBasketNew.some((element) => element === prod.ID) === true) {

      let removeArray = [];
      let anotherProductsApps = [];
      prodBasketRender.filter(el => el.ID !== prod.ID).map(elem => anotherProductsApps = elem.appArray.concat(anotherProductsApps))
      let arr_ = prod.appArray.filter(elem => !anotherProductsApps.includes(elem))

      // Исключили приложения в других продуктах
      let modernSystemsApp = appBasketRender.filter(elem => elem.isModernSystems === 1)
      if (modernSystemsApp.length > 0) {
        modernSystemsApp.map(msApp => {
          let dependencies = msApp.dependedApps.split(';').filter(elem => elem !== msApp.codeasvul)
          appBasketRender.filter(elem => arr_.includes(elem.ID)).map(app => {
            if (dependencies.length === 1 && dependencies.includes(app.codeasvul)) {
              removeArray.push(msApp.ID)
            } else if (dependencies.includes(app.codeasvul)) {
              let anotherDependedApp = dependencies.filter(elem => elem !== app.codeasvul)
              // console.log(anotherDependedApp, appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0)
              if (appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0) {
                removeArray.push(msApp.ID)
              }
            }
          })
        })
      }

      arr_ = arr_.concat(removeArray)


      localStorage.setItem('cartProd', JSON.stringify(prodBasketNew.filter(el_ => el_ !== prod.ID)))
      localStorage.setItem('cartApp', JSON.stringify(appBasketNew.filter(el => !arr_.includes(el))))
    } else {
      localStorage.setItem('cartProd', JSON.stringify(prodBasketNew.concat([prod.ID])))
      localStorage.setItem('cartApp', JSON.stringify(appBasketNew.concat(prod['AppsIDsNeeded'].replace(/\s/g, '').split(','), prod['AppsIDsRecommended'].replace(/\s/g, '').split(','))))
    }
    _addedDependencies(false)
    _resetState(!resetState)
  }

  useEffect(() => {
    const prodBasketNew = JSON.parse(localStorage.getItem('cartProd')) || []
    let notDeleteFromBasketArrR_ = []
    let notDeleteFromBasketArrN_ = []
    let sum1 = 0;
    let sum2 = 0;
    if (prodBasketNew.length > 0) {
      let didCancel = false;
      async function fetchData() {
        const cardinfo = await axios.get(`${serverAPI}/prodid/${prodBasketNew.join(",")}/${language}?inCu=${props.userCollection.inCu}`)
        if (!didCancel) {
          if (cardinfo && cardinfo.data && cardinfo.data[0]) {

            cardinfo.data.map(el => {
              sum1 += parseFloat(el.SumAppsNeeded) < 999998 ? parseFloat(el.SumAppsNeeded) : 0
              sum2 += parseFloat(el.SumAppsRecommended) < 999998 ? parseFloat(el.SumAppsRecommended) : 0

              if (el.AppsIDsRecommended && el.AppsIDsRecommended.length > 0) {
                notDeleteFromBasketArrR_ = notDeleteFromBasketArrR_.concat(el.AppsIDsRecommended.split(',').map(el => +el))
              }

              if (el.AppsIDsNeeded && el.AppsIDsNeeded.length > 0) {
                notDeleteFromBasketArrN_ = notDeleteFromBasketArrN_.concat(el.AppsIDsNeeded.split(',').map(el => +el))
              }
              el.AppsIDsNeededArr = el.AppsIDsNeeded.replace(/\s/g, '').split(',').map(elem => +elem)
              el.AppsIDsRecommendedArr = el.AppsIDsRecommended.replace(/\s/g, '').split(',').map(elem => +elem)
              el.appArray = el.AppsIDsNeededArr.concat(el.AppsIDsRecommendedArr.filter(elem => !el.AppsIDsNeededArr.includes(elem)))
              return el
            })
            setProdBasketRender(cardinfo.data)

            _notDeleteFromBasketArr(notDeleteFromBasketArr.concat(notDeleteFromBasketArrR_).concat(notDeleteFromBasketArrN_))
            _notDeleteFromBasketArrN(notDeleteFromBasketArrN_)
            _notDeleteFromBasketArrR(notDeleteFromBasketArrR_)

            _sumProdN(sum1)
            _sumProdR(sum2)

          } else {
            setProdBasketRender([])
          }
        }
      }
      fetchData();
      return () => {
        didCancel = true;
      }
    } else {
      setProdBasketRender([])
      _sumProdN(0)
      _sumProdR(0)
    }

  }, [resetState, language]);


  /** Продукты ++++++++ Конец*/


  const clearBasket = async () => {
    await props.saveCollection(undefined, 'clear', 'cart');
    window.location.reload()
  }

  useEffect(() => {
    let sum = 0;
    let sumCFT = 0;
    let sumMS = 0;
    // let sumR = 0
    // let sumN = 0
    if (appBasketRender.length > 0) {
      appBasketRender.filter(el => el.isHidePrice !== 1 && (props.userCollection.inCu === '1' && [0, 2].includes(el.Currency) || props.userCollection.inCu !== '1' && [1, 2].includes(el.Currency))).forEach(el => {
        //let hasAnotherCurrency = appBasketRender.filter(el => props.userCollection.inCu === '1' && el.Currency === 1 || props.userCollection.inCu !== '1' && el.Currency === 0 ).length > 0;
        if ((parseFloat(el.paymentone)) !== NaN) sum = sum + +el.paymentone

        if (el.isModernSystems === 1 && (parseFloat(el.paymentone)) !== NaN) {
          console.log(el.paymentone, sumMS)
          sumMS = sumMS + el.paymentone
        } else if ((parseFloat(el.paymentone)) !== NaN) {

          sumCFT = sumCFT + +el.paymentone
        }
        // if (notDeleteFromBasketArrN.includes(el.ID) && parseFloat(el.PaymentOne) !== NaN) sumN = sumN + el.PaymentOne
        // if (notDeleteFromBasketArrR.includes(el.ID) && parseFloat(el.PaymentOne) !== NaN) sumR = sumR + el.PaymentOne
      })
    }
    //  else {
    // }
    _sumApp(sum)
    _sumAppCFT(sumCFT)
    _sumAppMS(sumMS)
    // _sumAppN(sumAppN+sumN)
    // _sumAppR(sumAppR+sumR)

    /** Облачные сервисы сумма */


    /** Облачные сервисы сумма */



    /*
    let didCancel = false;
    async function fetchData() {

      let sum = 0
      let sumR = 0
      let sumN = 0

      const SUM_SQL = await axios.get(`${serverAPI}/cloud_apps_sum/${cloudBasket.join(',')}`)
      // sum = sum + SUM_SQL['data']['sum_need'] + SUM_SQL['data']['sum_recomend']
      sumR = sumR + SUM_SQL['data']['sum_recomend']
      sumN = sumN + SUM_SQL['data']['sum_need']

      if (appBasketRender.length > 0) {
        appBasketRender.forEach(el => {
          if (parseFloat(el.PaymentOne) !== NaN) sum = sum + el.PaymentOne
          if (notDeleteFromBasketArrN.includes(el.ID) && parseFloat(el.PaymentOne) !== NaN) sumN = sumN + el.PaymentOne
          if (notDeleteFromBasketArrR.includes(el.ID) && parseFloat(el.PaymentOne) !== NaN) sumR = sumR + el.PaymentOne

        })
      } 
      _sumApp(sum)
      _sumAppN(sumN)
      _sumAppR(sumR)

    }
    if (cloudBasketRender.length > 0) {
      fetchData();
    } else {
      let sum = 0
      let sumR = 0
      let sumN = 0
      if (appBasketRender.length > 0) {
        appBasketRender.forEach(el => {
          if (parseFloat(el.PaymentOne) !== NaN) sum = sum + el.PaymentOne
          if (notDeleteFromBasketArrN.includes(el.ID) && parseFloat(el.PaymentOne) !== NaN) sumN = sumN + el.PaymentOne
          if (notDeleteFromBasketArrR.includes(el.ID) && parseFloat(el.PaymentOne) !== NaN) sumR = sumR + el.PaymentOne

        })
        _sumApp(sum)
        _sumAppN(sumN)
        _sumAppR(sumR)
      }
    }

    

*/

  }, [appBasketRender, resetState])

  useEffect(() => {
    async function fetchData() {
      const prodBasketNew = JSON.parse(localStorage.getItem('cartProd')) || []
      const SUM_SQL = await axios.post(`${serverAPI}/getUniqueSum?inCu=${props.userCollection.inCu}`, { clouds: cloudBasket, products: prodBasketNew }) //await axios.get(`${serverAPI}/cloudappssum/${cloudBasket.join(',')}?products=`)
      let sumR = SUM_SQL['data']['sum_recomend']
      let sumN = SUM_SQL['data']['sum_need']
      // _sumApp(sumR+sumN+sumApp)
      // _sumAppN(sumN)
      // _sumAppR(sumR)
      _sumN(sumN)
      _sumR(sumR)
    }
    if (cloudBasketRender.length > 0 || prodBasketRender.length > 0) {
      fetchData();
    } else {
      _sumN(0)
      _sumR(0)
    }
  }, [cloudBasketRender, /*appBasketRender,*/, prodBasketRender, resetState])

  function removeNoCartAppFromAnalogs(obj, allowedKeys) {
    const entries = Object.entries(obj);
    const filteredEntries = entries.filter(([key]) => allowedKeys.includes(+key));
    return Object.fromEntries(filteredEntries);
  }

  const dataToExcel = async (exception) => {
    let objAnalogs = new Object();

    if (alternatives) {
      alternatives.map(o => {
        let d = o.DependID;
        let da = o.Alternatives;

        if (d in objAnalogs) {
          objAnalogs[d] = objAnalogs[d] + ',' + da
        } else {
          objAnalogs[d] = da;
        }
      })
    }

    // _loadingState(true)
    if (addedDependencies === true || exception === true) {
      const prodBasketNew = JSON.parse(localStorage.getItem('cartProd')) || ''
      //const appBasketNew = JSON.parse(localStorage.getItem('cartApp')) || ''
      let appsInProducts = [];
      let apps_ = getItemFromStorage('cartAppInProduct');
      //apps_.map(el => console.log('aappss',el.apps, typeof el.apps))
      apps_.map(el => appsInProducts = appsInProducts.concat(...el.apps))
      const appBasketNew = getItemFromStorage('cartApp').concat(appsInProducts)
      const exportAnalogs = removeNoCartAppFromAnalogs(objAnalogs, appBasketNew);
      const result = await axios.post(`${serverAPI}/exports`,
        {
          applications: appBasketNew,
          analogs: exportAnalogs,
          products: prodBasketNew,
          clouds: cloudBasket,
          lang: language,
          kloStatuses: Object.keys(kloStatuses).length > 0 && kloUser && kloUser.user && kloUser.user.IS_CFT === '1' ? kloStatuses : undefined
        })
      // const result = await axios.get(`${serverAPI}/export/${language}?applications=${appBasketNew}&products=${prodBasketNew}&clouds=${cloudBasket}`);
      if (result.status === 200) {
        window.open(`${result.data}`);
        // _loadingState(false)
      } else {

      }
    } else {
      handleClickLoad()
    }
  }

  useEffect(() => {
    if (window.innerWidth < 1366) {
      setView('tile')
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (pageProd > Math.trunc((prodBasketRender.length - 1) / 24) + 1) {
      setPageProd(1);
    }

    if (page > Math.trunc((filterApps(appBasketRender).length - 1) / 24) + 1) {
      setPage(1);
    }
  }, [prodBasketRender, appBasketRender])

  const handleModalAskCFT = () => {
    setAskCFT(true)
    setAddXLSX(false)
    setStateAsk(!stateAsk)
  }

  const handleModalAddXLSX = () => {
    setAddXLSX(true)
    setAskCFT(false)
    setStateAsk(!stateAsk)
  }

  // useEffect(() => {
  //   if (first) {
  //     view === 'tile' ?
  //       history.push({ search: history.location.search.replace('?view=table', '?view=tile') }) :
  //       history.push({ search: history.location.search.replace('?view=tile', '?view=table') })
  //   }
  // }, [view]);
  //console.log(appBasketRender)

  const filterApps = (apps) => {
    const filteredAppsByKlostatus = (apps) => {
      let statuses = filterStatusKlo.map(el => el.id.toUpperCase())
      const compareStatuses = (app) => {
        let kloStatus = kloStatuses[app.codeasvul];
        let { status, hasDecision, usage } = typeof kloStatus === 'object' ? kloStatus : {};
        //console.log(statuses.includes(status) || (filterStatusKlo.includes('В процессе оформления покупки') && hasDecision === true) || (statuses.includes('НЕТ ДАННЫХ') && status === undefined),  , hasDecision === true)
        return statuses.includes(status) && hasDecision === false || (statuses.includes('В ПРОЦЕССЕ ОФОРМЛЕНИЯ ПОКУПКИ') && hasDecision === true) || (statuses.includes('НЕТ ДАННЫХ') && status === undefined) || (hasDecision === true && status !== 'КУПЛЕНО' && (statuses.includes('В ПРОЦЕССЕ ОФОРМЛЕНИЯ ПОКУПКИ (ИСПОЛЬЗУЕТСЯ)') && /*status.indexOf('(ИСПОЛЬЗУЕТСЯ)') > -1*/ usage === '(ИСПОЛЬЗУЕТСЯ)' || statuses.includes('В ПРОЦЕССЕ ОФОРМЛЕНИЯ ПОКУПКИ (НЕ ИСПОЛЬЗУЕТСЯ)') && /*status.indexOf('(НЕ ИСПОЛЬЗУЕТСЯ)') > -1*/usage === '(НЕ ИСПОЛЬЗУЕТСЯ)'))
      }
      return filterStatusKlo.length === 0 ? apps : apps.filter(el => compareStatuses(el))
    }
    apps = filteredAppsByKlostatus(apps)
    //console.log(apps, filterStatusKlo)
    return currentSystems.length === 0 ? apps : apps.filter(elem => currentSystems.includes(elem.Title_catalog))
  }

  function renderCostMS() {
    if (systems.length > 0 && systems.includes("Современные Системы")) {
      return (
        <Grid item style={{ marginTop: 11 }}>
          <Typography compoheht="p" className={classes.Body2}>{translate.Words[`TotalcostCFT${language}`]}: {
            parseFloat(sumAppCFT).toFixed(3).substr(-1) === "0"
              ?
              parseFloat(sumAppCFT).toFixed(2)
              :
              parseFloat(sumAppCFT).toFixed(3)
          } {translate.Words[`YeRu${language}`]}  </Typography>

          <Typography compoheht="p" className={classes.Body2}>{translate.Words[`TotalcostMS${language}`]}: {
            props.userCollection.inCu === '1'
              ?
              "-"
              :
              parseFloat(sumAppMS).toFixed(3).substr(-1) === "0"
                ?
                parseFloat(sumAppMS).toFixed(2)
                :
                parseFloat(sumAppMS).toFixed(3)
          } {translate.Words[`YeRu${language}`]}</Typography>
        </Grid>
      )
    }
  }

  const addApptoDicisions = async () => {
    const apps = appBasketRender.filter(el => el.url_catalog === "cftbank");
    if (apps.length > 0) {
      props._isSynchronnyLoading(true);
      //   const checkedApps = await axios.post(`${utils.getKLOLink()}/addCatalogApps`,  
      //   {
      //     apps:apps.map(el => el.codeasvul).join(','),server_part:kloUser.currentServerPart},
      //     {withCredentials: true,
      //       headers: {
      //       "Access-Control-Allow-Origin": "https://catalog.cft.ru/",
      //       'Cache-Control': 'cache',
      //       'Pragma': 'cache',
      //       'Expires': '0',
      // }})

      // if (checkedApps && checkedApps.data && checkedApps.data.items && Array.isArray(checkedApps.data.items) && checkedApps.data.items.length > 0) {
      const addApps = await axios.post(`${utils.getKLOLink()}/addCatalogApps`,
        {
          apps: apps.map(el => el.codeasvul), server_part: kloUser.currentServerPart
        },
        {
          withCredentials: true,
          headers: {
            "Access-Control-Allow-Origin": "https://catalog.cft.ru/",
            'Cache-Control': 'cache',
            'Pragma': 'cache',
            'Expires': '0',
          }
        }).catch((e) => props._isSynchronnyLoading(false));
      props._isSynchronnyLoading(false);
      if (addApps && addApps.data && addApps.data.result && addApps.data.result === 'ok') {
        window.open(`${utils.getKLOLink()}/decisions`, 'klo')
      } else if (addApps && addApps.data && addApps.data.error && addApps.data.error === 'nothingToAdd') {
        _snackbarInfo([true, 'В корзине отсутствуют приложения, возможные для добавления в Список Решений'])
      }
    }

  }

  const renderChips = () => {
    if (systems.length > 0 && appBasketRender.length > 0) {
      if (window.innerWidth < 1032) {
        return (
          <Grid item container style={{ margin: '23px auto 4px ' }}>
            <React.Fragment>
              <Grid item style={{ width: "100%", textAlign: "center" }}>
                <StyledToggleButton
                  value={false}
                  selected={expAccordion}
                  onChange={() => _expAccordion(!expAccordion)}
                  aria-label="left aligned"
                >
                  {expAccordion === true ? <ChevronIcon fill={"#BCBBD0"} transform={"rotate(270deg)"} /> : <ChevronIcon fill={"#BCBBD0"} transform={"rotate(90deg)"} />}
                  <Typography className={expAccordion === true ? classes.STBsel : classes.STBtxt}>{expAccordion === true ? "Скрыть категории" : "Показать категории"}</Typography>
                </StyledToggleButton>
              </Grid>

              <Accordion expanded={expAccordion}>
                <AccordionSummary />

                <AccordionDetails>
                  <Grid container direction='row'>
                    <Chip
                      className={clsx({
                        [classes.filterChip]: currentSystems.length !== 0,
                        [classes.filterChipSelected]: currentSystems.length === 0
                      })}
                      label={translate.Words['All' + language] + ' (' + appBasketRender.length + ')'}
                      onClick={() => { _currentSystems([]) }}
                    />
                    {sortSystems.map((system, index) => {
                      const isActiv = currentSystems.includes(system)
                      let appsCount = appBasketRender.filter(elem => elem.Title_catalog === system).length
                      const ChipClassNames = system === "Современные Системы"
                        ?
                        clsx({
                          [classes.filterChipMS]: !isActiv,
                          [classes.filterChipMSSelected]: isActiv
                        })
                        :
                        clsx({
                          [classes.filterChip]: !isActiv,
                          [classes.filterChipSelected]: isActiv
                        })
                      if (appsCount > 0) { // https://jirabs.ftc.ru/browse/CTG-311
                        return (
                          <Chip
                            className={ChipClassNames}
                            label={`${system} (${appsCount})`}
                            onClick={() => { let newSystems = currentSystems.includes(system) ? currentSystems.filter(elem => elem !== system) : currentSystems.concat(system); _currentSystems(newSystems.length === sortSystems.length && newSystems.length !== 1 ? [] : newSystems); setPage(1) }}
                          />
                        )
                      }
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </React.Fragment>
          </Grid>
        )
      } else {
        return (
          <Grid item container style={{ margin: '23px auto 40px ' }}>
            <Grid container direction='row'>
              <Chip
                className={clsx({
                  [classes.filterChip]: currentSystems.length !== 0,
                  [classes.filterChipSelected]: currentSystems.length === 0
                })}
                label={translate.Words['All' + language] + ' (' + appBasketRender.length + ')'}
                onClick={() => { _currentSystems([]) }}
              />
              {sortSystems.map((system, index) => {
                const isActiv = currentSystems.includes(system)
                let appsCount = appBasketRender.filter(elem => elem.Title_catalog === system).length
                const ChipClassNames = system === "Современные Системы"
                  ?
                  clsx({
                    [classes.filterChipMS]: !isActiv,
                    [classes.filterChipMSSelected]: isActiv
                  })
                  :
                  clsx({
                    [classes.filterChip]: !isActiv,
                    [classes.filterChipSelected]: isActiv
                  })
                if (appsCount > 0) { // https://jirabs.ftc.ru/browse/CTG-311
                  return (
                    <Chip
                      className={ChipClassNames}
                      label={`${system} (${appsCount})`}
                      onClick={() => { let newSystems = currentSystems.includes(system) ? currentSystems.filter(elem => elem !== system) : currentSystems.concat(system); _currentSystems(newSystems.length === sortSystems.length && newSystems.length !== 1 ? [] : newSystems); setPage(1) }}
                    />
                  )
                }
              })}
            </Grid>
          </Grid>
        )
      }
    }
  }

  const hasAppsToDecision = kloUser.user && kloUser.user.IS_BANK && appBasketRender.filter(el => el.url_catalog === "cftbank").length > 0
  const updateArr = (collection, row, type) => {
    if (collection === 'cart') {
      console.log('update', row, type, appBasket)
      if (type === 'app' && appBasketRender.map(el => el.ID).includes(row.ID)) {
        /*if (Array.isArray(item) && isAddingDependApps) {
          appFavorite_ = appFavorite.concat(item);
        } else {
          appFavorite_ = appFavorite.includes(item) ? appFavorite.filter(el => el !== item) : appFavorite.concat(item);
        }*/
        let id = row.ID
        let removeArray = [];
        const appBasketNew = JSON.parse(localStorage.getItem('cartApp') || [])
        let modernSystemsApp = appBasketRender.filter(elem => elem.isModernSystems === 1)
        if (modernSystemsApp.length > 0) {
          modernSystemsApp.map(msApp => {
            let dependencies = msApp.dependedApps.split(';').filter(elem => elem !== msApp.codeasvul)

            if (dependencies.length === 1 && dependencies.includes(row.codeasvul)) {
              removeArray.push(msApp.ID)
            } else if (dependencies.includes(row.codeasvul)) {

              let anotherDependedApp = dependencies.filter(elem => elem !== row.codeasvul)
              // console.log(anotherDependedApp, appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0)
              if (appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0) {
                removeArray.push(msApp.ID)
              }
            }
          })
        }
        removeArray.push(row.ID)
        // console.log(modernSystemsApp)

        if (appBasketNew.some((element) => element === row.ID) === true) {

          if (currentSystems.length === 1 && row.Title_catalog === currentSystems[0] && appBasketRender.filter(elem => elem.Title_catalog === currentSystems[0]).length === 1) {
            _currentSystems([]);
          }
          localStorage.setItem('cartApp', JSON.stringify(appBasketNew.filter(el_ => !removeArray.includes(el_))))
        }
        //_addedDependencies(false)
        setAppBasketRender(appBasketRender.filter(elem => !removeArray.includes(elem.ID)))

        _appBasket(appBasket.filter(el_ => !removeArray.includes(el_)));

        fetchAnalogsData(appBasketRender.filter(elem => !removeArray.includes(elem.ID)).map(el => el.ID));
        //props.saveCollection(appBasket.filter(el_ => !removeArray.includes(el_)), 'app','cart', undefined, true)
        //setAppBasketRender(appBasketRender.filter(app => app.ID !== id))
      } else if (prodBasketRender.map(el => el.ID).includes(row.ID)) {
        // const prodBasketNew = JSON.parse(localStorage.getItem('favoriteProduct')) || []
        // const appBasketNew = getItemFromStorage('favoriteApp')
        // if (prodBasketNew.some((element) => element === prod.ID) === true) {
        let prod = row
        let removeArray = [];
        let anotherProductsApps = [];
        let prodBasketRenderNew = prodBasketRender.filter(el => el.ID !== prod.ID);
        prodBasketRenderNew.map(elem => anotherProductsApps = elem.appArray.concat(anotherProductsApps))
        let arr_ = prod.appArray.filter(elem => !anotherProductsApps.includes(elem))

        // Исключили приложения в других продуктах
        let modernSystemsApp = appBasketRender.filter(elem => elem.isModernSystems === 1)
        if (modernSystemsApp.length > 0) {
          modernSystemsApp.map(msApp => {
            let dependencies = msApp.dependedApps.split(';').filter(elem => elem !== msApp.codeasvul)
            appBasketRender.filter(elem => arr_.includes(elem.ID)).map(app => {
              if (dependencies.length === 1 && dependencies.includes(app.codeasvul)) {
                removeArray.push(msApp.ID)
              } else if (dependencies.includes(app.codeasvul)) {
                let anotherDependedApp = dependencies.filter(elem => elem !== app.codeasvul)
                // console.log(anotherDependedApp, appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0)
                if (appBasketRender.filter(elem => anotherDependedApp.includes(elem.codeasvul)).length === 0) {
                  removeArray.push(msApp.ID)
                }
              }
            })
          })
        }

        arr_ = arr_.concat(removeArray)
        setAppBasketRender(appBasketRender.filter(elem => !arr_.includes(elem.ID)))
        setProdBasketRender(prodBasketRenderNew)
        _addedDependencies(false)
        fetchAnalogsData(appBasketRender.filter(elem => !removeArray.includes(elem.ID)).map(el => el.ID));
      }
    }

  }

  const renderAppSumm = () => {
    let hasHiddenPrices = appBasketRender.filter(el => el.isHidePrice === 1).length > 0;
    let hasAnotherCurrency = appBasketRender.filter(el => el.isHidePrice !== 1 && (props.userCollection.inCu === '1' && el.Currency === 1 || props.userCollection.inCu !== '1' && el.Currency === 0)).length > 0;
    let title = `Без учета приложений с ценой покупки ${hasHiddenPrices ? '«По запросу»' : ''}${hasHiddenPrices && hasAnotherCurrency ? ' и ' : ''}${hasAnotherCurrency ? 'в валюте, отличной от выбранной' : ''}`

    return (
      hasHiddenPrices || hasAnotherCurrency
        ?
        <CustomTooltip title={title}>
          <Typography compoheht="h3" className={classes.Title3}> {translate.Words[`Totalcost${language}`]}: {
            parseFloat(sumApp).toLocaleString('ru-RU', { maximumFractionDigits: 3 })

          }  {utils.getPriceItem(props.userCollection.inCu, language)}*</Typography>

        </CustomTooltip>
        :
        <Typography compoheht="h3" className={classes.Title3}> {translate.Words[`Totalcost${language}`]}: {
          parseFloat(sumApp).toLocaleString('ru-RU', { maximumFractionDigits: 3 })
        } {utils.getPriceItem(props.userCollection.inCu, language)}</Typography>

    )

  }
  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="flex-start"
    >
      <Grid /* panel/title */
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{ marginTop: 3 }}
      >
        <Grid item sm={6} xs={12}>
          <Typography className={classes.Header}>{translate.Letters[`Cart${language}`]}</Typography>
        </Grid>

        {/* <Grid item md={3} sm={6} xs={12}>
            <Link href="/basket" onClick={preventDefault} className={classes.Body1}>Сохранённые комплектации</Link>
          </Grid> */}
      </Grid>

      <Grid /* actions/subtitle */
        container
        direction="row"
        justify="space-between"
        style={{ marginTop: 65 }}
      >
        <Grid item style={{ marginTop: 9 }} xs={12}>
          <Grid item container direction="row" justify="space-between">
            <Grid item lg={window.innerWidth < 1702 ? 8 : 9} md={window.innerWidth < 1702 ? 8 : 9} sm={12}>
              <Grid item>
                {
                  renderAppSumm()
                }
              </Grid>

              {
                renderCostMS()
              }


              <Grid item style={{ marginTop: 11 }}>
                <Typography compoheht="p" className={classes.Body1}>{translate.Words[`RequiredApplicationscost${language}`]}: {
                  parseFloat(sumN).toFixed(3).substr(-1) === "0"
                    ?
                    parseFloat(sumN).toFixed(2)
                    :
                    parseFloat(sumN).toFixed(3)
                } {translate.Words[`YeRu${language}`]}  </Typography>
                <Typography compoheht="p" className={classes.Body1}>{translate.Words[`RecommendedApplicationscost${language}`]}: {
                  parseFloat(sumR).toFixed(3).substr(-1) === "0"
                    ?
                    parseFloat(sumR).toFixed(2)
                    :
                    parseFloat(sumR).toFixed(3)
                } {translate.Words[`YeRu${language}`]}</Typography>
              </Grid>
              {
                window.innerWidth < 1032
                  ?
                  null
                  :

                  <Grid item style={{ marginTop: 27 }}>
                    <Grid item container direction="row" justify="flex-start" alignItems="center">
                      {/* <Grid item>
                        <SecondaryButton height={55} text={'Сохранить комплектацию'} />
                      </Grid> */}

                      {/* { kloUser && kloUser.user && kloUser.user.IS_CFT === '1'
                    ?
                    null: */}
                      <Grid item style={{ marginRight: 16 }} >
                        <BasketAskCFT
                          usname={props.usname}
                          setUsname={props.setUsname}
                          isAuth={props.isAuth}
                          setIsAuth={props.setIsAuth}
                          stateAsk={stateAsk}
                          setStateAsk={setStateAsk}
                          AskCFT={askCFT}
                          AddXLSX={addXLSX}
                          submit={'ask'}
                        />
                        {/* <a class="mailto" href="mailto:contact@test.com">Mail</a> */}
                        {/* <Link className={classes.PrimaryLink} href={mailTo}>{translate.Words[`DiscussWithCFT${language}`]} </Link>  был вызов письма*/}
                        {/* <Link className={classes.PrimaryLink} onClick={() => setStateAsk(!stateAsk)}>{translate.Words[`DiscussWithCFT${language}`]} </Link> */}

                        <HtmlTooltip
                          interactive
                          disableFocusListener={props.isAuth}
                          disableHoverListener={props.isAuth}
                          disableTouchListener={props.isAuth}
                          title={
                            !props.isAuth
                              ?
                              language === 'Ru'
                                ?
                                <Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы отправить сообщение</Grid>
                                :
                                <Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to send message</Grid>
                              :
                              null
                          }
                        >
                          <Grid item>
                            <PrimaryButtonBasketAsk
                              width={216}
                              height={55}
                              disabled={(appBasketRender.length > 0 || prodBasketRender.length > 0 || cloudBasketRender.length > 0) && props.isAuth ? false : true}
                              text={translate.Words[`DiscussWithCFT${language}`]}
                              onClick={() => handleModalAskCFT()}
                            />
                          </Grid>
                        </HtmlTooltip>
                      </Grid>

                      {/* } */}
                      {
                        props.isAuth && (kloUser.user && ((kloUser.user.IS_BANK === '1' && (kloUser.user.KLO_USERS_BANKS === '1' || kloUser.user.KLO_EDO_BANK === '1')) || (kloUser.user.IS_CFT === '1' && (kloUser.user.KLO_USER === '1' && (kloUser.user.CI_SUPPORT_DIRECTOR === '1')))) && hasAppsToDecision)
                          ?
                          <Tooltip title={translate.Words[`SendListSolutions_${language}`]}>
                            <Grid item style={{ marginRight: 16 }} >
                              <PrimaryButtonBasketBuy width={216} height={55} text={kloUser.user.IS_BANK === '1' ? translate.Words[`Buy_${language}`] : translate.Words[`Sell_${language}`]} onClick={() => addApptoDicisions()} />
                            </Grid>
                          </Tooltip>
                          :
                          null
                      }

                      {/* <IconButton aria-label="delete" style={{ background: '#FFFFFF', boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)', height: 48 }} className={classes.margin}>
                  <a href={mailTo1}>
                    <ShareIcon fill={'#BCBBD0'} />
                  </a>
                </IconButton> */}
                    </Grid>
                  </Grid>
              }
            </Grid>

            <Grid item lg={window.innerWidth < 1702 ? 4 : 3} md={window.innerWidth < 1702 ? 4 : 3} sm={12} className={classes.ExtActionsCntr}>
              {/* <AddAppsFromXLSX /> */}
              <Grid item container direction="row" style={{ marginBottom: 24, cursor: 'pointer' }} AddXLSX={true} onClick={() => {if ( appBasket && appBasket.length !== 0 || appBasketRender.length > 0){addDependency()}}}>
                <RoundTableIcon fill={'#BCBBD0'} fontSize="inherit" />
                <Typography style={{ marginLeft: 29 }} className={classes.Body11} component="span">{translate.Words[`AddDependencies${language}`]} </Typography>
              </Grid>

              <Grid item container direction="row" style={{ marginBottom: 24, cursor: 'pointer' }} AddXLSX={true} onClick={() => handleModalAddXLSX()}>
                <AddAppIcon fill={'#BCBBD0'} />
                <Typography style={{ marginLeft: 29 }} className={classes.Body11} component="span">{translate.Words[`AddPackage${language}`]} </Typography>
              </Grid>

              {/* <Grid item container direction="row" style={{ margin: "24px 0" }}>
              <AddAppIcon fill={'#BCBBD0'} />
              <Typography style={{ marginLeft: 29 }} className={classes.Body11} component="span">Добавить приложение по коду</Typography>
            </Grid> */}

              <Grid item container direction="row" style={{ margin: "24px 0", cursor: "pointer" }} onClick={() => dataToExcel()}>
                <DocIcon fill={'#BCBBD0'} />
                <Typography style={{ marginLeft: 29 }} className={classes.Body11} component="span">{translate.Words[`Download${language}`]}  </Typography>
              </Grid>

              {/* {
                kloUser.user && ((kloUser.user.IS_BANK === '1' && kloUser.user.KLO_USERS_BANKS === '1' ) || (kloUser.user.IS_CFT === '1' && (kloUser.user.KLO_USER === '1' &&(/*kloUser.user.CI_SUPPORT === '1' ||  kloUser.user.CI_SUPPORT_DIRECTOR === '1' )) ))  && hasAppsToDecision
                /*?
                <Tooltip title='В Список Решений можно отправить пока только Приложения Каталога ЦФТ-Банк. 1 Серверную часть'>
                  <Grid item container direction="row" style={{ marginTop: 24, cursor: "pointer" }} onClick={() => addApptoDicisions()}>
                  
                    <ShoppingBasket  style={{fill:'rgb(188, 187, 208'}} />
                    <Typography style={{ marginLeft: 29 }} className={classes.Body11} component="span">{'Добавить в список Решений'}</Typography>
                  </Grid>
                </Tooltip>
                :
                null
              } */}

              <Grid item container direction="row" style={{ marginTop: 24, cursor: "pointer" }} onClick={() => handleClick()}>
                {/* <ClearIcon fill={'#BCBBD0'} /> */}
                <ClearIcon fill={'#BCBBD0'} />
                <Typography style={{ marginLeft: 29 }} className={classes.Body11} component="span">{translate.Words[`Clear${language}`]}</Typography>
              </Grid>

            </Grid>
          </Grid>

          {
            window.innerWidth < 1032 ?
              <Grid item style={{ marginTop: 27 }}>
                <Grid item container direction="row" justify="flex-start" alignItems="center">
                  {/* { kloUser && kloUser.user && kloUser.user.IS_CFT === '1'
                    ?
                    null
                    : */}
                  <Grid item style={{ marginRight: 16 }} >
                    <BasketAskCFT
                      usname={props.usname}
                      setUsname={props.setUsname}
                      isAuth={props.isAuth}
                      setIsAuth={props.setIsAuth}
                      stateAsk={stateAsk}
                      setStateAsk={setStateAsk}
                      AskCFT={askCFT}
                      AddXLSX={addXLSX}
                      submit={'ask'}
                    />

                    <PrimaryButtonBasketAsk
                      height={55}
                      width={216}
                      disabled={(appBasketRender.length > 0 || prodBasketRender.length > 0 || cloudBasketRender.length > 0) && props.isAuth ? false : true}
                      text={translate.Words[`DiscussWithCFT${language}`]}
                      onClick={() => handleModalAskCFT()}
                    />
                  </Grid>
                  {/* // }          */}
                  {
                    props.isAuth && (kloUser.user && ((kloUser.user.IS_BANK === '1' && (kloUser.user.KLO_USERS_BANKS === '1' || kloUser.user.KLO_EDO_BANK === '1')) || (kloUser.user.IS_CFT === '1' && (kloUser.user.KLO_USER === '1' && (kloUser.user.CI_SUPPORT_DIRECTOR === '1')))) && hasAppsToDecision)
                      ?
                      <Tooltip title={translate.Words[`SendListSolutions_${language}`]}>
                        <Grid item style={{
                          marginRight: 16,
                          marginTop: 24
                        }}>
                          <PrimaryButtonBasketBuy width={216} height={55} text={kloUser.user.IS_BANK === '1' ? translate.Words[`Buy_${language}`] : translate.Words[`Sell_${language}`]} onClick={() => addApptoDicisions()} />
                        </Grid>
                      </Tooltip>
                      :
                      null
                  }
                </Grid>
              </Grid>
              :
              null
          }
        </Grid>
      </Grid>

      <Grid /* actions/subtitle */
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{ marginTop: 60 }}
      >
        <React.Fragment> {/* TODO_(ARH): РАЗОБРАТЬСЯ С КОМПОНЕНТОМ TABS И ВЫНЕСТИ ЕГО ВОВНЕ */}
          <Grid container>
            <Grid item container justify="space-between" direction="row">
              <Grid item style={{ overflowX: 'auto' }}>
                <StyledTabs
                  value={valueBasketTab}
                  onChange={changeBasketTab}
                  variant="scrollable"
                  aria-label="styled tabs example"
                >
                  {props.menu.find(category => category.ID_Category === 3 && category.isArchive === 0) ? <StyledTab label={`${translate.Words[`Applications_${language}`]} ${(appBasketRender && appBasketRender.length) || 0}`} /> : null}
                  {props.menu.find(category => category.ID_Category === 2 && category.isArchive === 0) ? <StyledTab label={`${translate.Words[`Products${language}`]} ${(prodBasketRender && prodBasketRender.length) || 0}`} /> : null}
                  {props.menu.find(category => category.ID_Category === 4 && category.isArchive === 0) ? <StyledTab label={`${translate.Words[`CloudServices${language}`]}  ${(cloudBasketRender && cloudBasketRender.length) || 0}`} /> : null}
                  {/* <StyledTab label="Готовые решения 0" /> */}
                </StyledTabs>
              </Grid>

              {/* <Grid item style={{ width: 'calc(100% - 691px)' }}>
                  <Typography component="h3" className={classes.Title3}>
                    Найдено 30 совпадений
                  </Typography>
                </Grid> */}

              <Grid item container className={classes.cntrChangeView}>
                <Grid item style={{ width: 224, display: valueBasketTab !== 0 || appBasketRender?.length < 1 || view === 'tbl' ? 'none' : 'block' }}>
                  <CustomSelect
                    data={
                      [
                        { id: 'codeAsvulSortA', name: language === 'Ru' ? 'По коду \u{1F856}' : 'By code \u{1F856}' }, // 🡖
                        { id: 'codeAsvulSortD', name: language === 'Ru' ? 'По коду \u{1F855}' : 'By code \u{1F855}' }, // 🡕
                        { id: 'sortingdatestartsaleD', name: language === 'Ru' ? 'По дате выпуска \u{1F855}' : 'By release date \u{1F855}' },
                        { id: 'sortingdatestartsaleA', name: language === 'Ru' ? 'По дате выпуска \u{1F856}' : 'By release date \u{1F856}' },
                        { id: 'versionD', name: language === 'Ru' ? 'По версии \u{1F855}' : 'By version \u{1F855}' },
                        { id: 'versionA', name: language === 'Ru' ? 'По версии \u{1F856}' : 'By version \u{1F856}' },
                      ]
                    }
                    value={sortingSelectVal}
                    tooltip={translate.Words[`Sorting_${language}`]}
                    defaultValue={sortingSelectVal}
                    func={(e) => _sortingSelectVal(e.target.value)}
                  />
                </Grid>

                <Grid item className={classes.cntrChangeViewArray}>
                  <ChangeViewArray
                    selected={view === 'tile' ? 1 : view === 'table' ? 0 : 2}
                    handleView={handleStrockList}
                    bank={props.bank}
                    page={window.innerWidth > 1365 ? 'applist' : ''}
                    disabled2={valueBasketTab !== 0 && valueBasketTab !== 1}
                  />
                </Grid>
                {
                  kloUser && kloUser.user && Object.keys(kloStatuses).length > 0//kloUser.user.IS_CFT === '1'
                    ?
                    <Grid item>

                      <CustomTooltip title={language === 'Ru' ? 'Фильтр' : "Filter"}>
                        <IconButton onClick={() => _statusFilter(true)} aria-label="filter" className={classes.btnFilter}>
                          {/* TODO: Бейдж по стейту фильтров */}
                          {filterStatusKlo.length > 0 ?
                            <StyledBadge
                              color="secondary"
                              variant="dot"
                            >
                              <FilterIcon />
                            </StyledBadge>
                            :
                            <FilterIcon />}
                        </IconButton>
                      </CustomTooltip>

                    </Grid>
                    :
                    null
                }

                {
                  kloUser && kloUser.user && Object.keys(kloStatuses).length > 0//kloUser.user.IS_CFT === '1'
                    ?
                    <Drawer
                      anchor={"right"}
                      open={statusFilter}
                      onClose={() => _statusFilter(false)}
                    // className={classes.root}
                    >
                      <Grid item className={classes.FilterHeaderCntr}>
                        <Grid container direction="row" justify="space-between" alignItems="center" style={{ padding: '12px 12px 12px 24px' }} /* style={{ position: 'fixed', width: 334, background: '#FFF', paddingTop: 32, paddingLeft: 24, zIndex: 2 }} */>
                          <Grid item>
                            <Typography className={classes.filterHeader}>
                              {translate.Words[`Filter${language}`]}
                            </Typography>
                          </Grid>

                          <Grid item className={classes.btnClose}>
                            <IconButton onClick={() => _statusFilter(false)} aria-label="filter">
                              <CloseIcon fill='#BCBBD0' />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid style={{ height: 'calc(100% - 108px)', overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}>
                        <Grid item container direction="column" className={classes.FilterBodyCntr} style={{ padding: '0 24px', width: 339 }}>

                          <FormControl component="fieldset" style={{ maxWidth: 285 }}>
                            <Typography className={classes.header}>{'Статус КЛО'}:</Typography>
                            <SubFilterList systema={props.bank} data={availableStatuses.map(item => { return { title: item, id: item } })} key1='id' key2={`title`} ids={filterStatusKlo} header={'Статус КЛО'} paramName='section' setBefore={(item) => { _filterStatusKlo(filterStatusKlo.map(el => el.id).includes(item.id) ? filterStatusKlo.filter(el => el.id !== item.id) : filterStatusKlo.concat(item)) }} />
                            <Grid item style={{ paddingTop: 8 }}>
                              <ChipArrayRed chipData={filterStatusKlo} key1={'id'} key2={`title`} handleDelete={(item) => _filterStatusKlo(filterStatusKlo.filter(el => el.id !== item.id))} />
                            </Grid>
                          </FormControl>


                        </Grid>
                      </Grid>

                      <Grid item className={classes.FilterActionCntr}>
                        <FilterButton variant="contained" className={classes.btnSecondary} onClick={() => { _filterStatusKlo([]); _statusFilter(false) }}>{translate.Words[`ResetFilters${language}`]}</FilterButton>
                      </Grid>
                    </Drawer>

                    :
                    null
                }
              </Grid>
            </Grid>

            {/* <Typography className={classes.padding} /> */}
            <Grid item container>
              {/* ===== ПРИЛОЖЕНИЯ =============== */}

              <TabPanel value={valueBasketTab} index={0} style={{ width: '100%', minHeight: 74 }}>
                {renderChips()}

                <React.Fragment>
                  <Grid container spacing={3} style={{ marginTop: -14, overflowY: 'auto' }}>
                    {view === 'tile' ?
                      loading
                        ?
                        <SkeletonCardTable />
                        :
                        <AllAppsTable
                          setAppBasket={setAppBasket}
                          notDeleteFromBasketArrCloud={notDeleteFromBasketArrCloud}
                          notDeleteFromBasketArr={notDeleteFromBasketArr}
                          type={'applications'}
                          language={language}
                          setAppBasketA={_appBasket}
                          removeApp={removeApp}
                          IsRu={props.IsRu}
                          readLink={false}
                          cardArr={filterApps(appBasketRender).filter((el, i) => i >= (page - 1) * 24 && i < page * 24)}
                          basket={true}
                          cart={true}
                          mt={'0px'}
                          page={page}
                          arrayTag={arrayTag}
                          setArrayTag={setArrayTag}
                          clearChips={clearChips}
                          kloStatuses={kloStatuses}
                          kloUser={kloUser}
                          loadingKloStatuses={loadingKloStatuses}
                          userCollection={props.userCollection}
                          saveCollection={props.saveCollection}
                          updateArr={updateArr}
                          appAlternatives={alternatives}
                        />
                      :
                      view === 'table' ?
                        loading
                          ?
                          <SkeletonCardTile />
                          :
                          <AllAppsTile
                            setAppBasket={setAppBasket}
                            notDeleteFromBasketArrCloud={notDeleteFromBasketArrCloud}
                            notDeleteFromBasketArr={notDeleteFromBasketArr}
                            type={'applications'}
                            language={language}
                            setAppBasketA={_appBasket}
                            removeApp={removeApp}
                            IsRu={props.IsRu}
                            readLink={false}
                            cardArr={filterApps(appBasketRender).filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
                            basket={true}
                            cart={true}
                            page={page}
                            arrayTag={arrayTag}
                            setArrayTag={setArrayTag}
                            clearChips={clearChips}
                            kloStatuses={kloStatuses}
                            kloUser={kloUser}
                            loadingKloStatuses={loadingKloStatuses}
                            userCollection={props.userCollection}
                            saveCollection={props.saveCollection}
                            updateArr={updateArr}
                            appAlternatives={alternatives}
                          />
                        :
                        <AllAppsTbl
                          key={3}
                          // arrayTag={arrayTag}
                          // setArrayTag={setArrayTag}
                          setAppBasket={setAppBasket}
                          notDeleteFromBasketArrCloud={notDeleteFromBasketArrCloud}
                          notDeleteFromBasketArr={notDeleteFromBasketArr}
                          basket={true}
                          type={'applications'}
                          language={language}
                          setAppBasketA={_appBasket}
                          removeApp={removeApp}
                          readLink={false}
                          cardArr={filterApps(appBasketRender)}
                          bank={props.bank}
                          cart={true}
                          arrayTag={arrayTag}
                          setArrayTag={setArrayTag}
                          clearChips={clearChips}
                          kloStatuses={kloStatuses}
                          kloUser={kloUser}
                          loading={loading}
                          loadingKloStatuses={loadingKloStatuses}
                          userCollection={props.userCollection}
                          saveCollection={props.saveCollection}
                          updateArr={updateArr}
                        // checkAll={checkAll}
                        // setCheckAll={setCheckAll}
                        />
                    }
                  </Grid>

                  {view !== 'tbl' && filterApps(appBasketRender).length > 0
                    ?
                    <Grid item container style={{ display: Math.trunc((filterApps(appBasketRender).length - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, paddingLeft: 1, alignItems: 'center' }} >
                      {Math.trunc((filterApps(appBasketRender).length - 1) / 24) > 0
                        ?
                        <Pagination className={classes.newPagination} count={Math.trunc((filterApps(appBasketRender).length - 1) / 24) + 1} page={page} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePage} />
                        :
                        null
                      }
                      <KloBanksChoose kloUser={kloUser} _kloUser={props._kloUser}
                        delta={Math.trunc((filterApps(appBasketRender).length - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : 345} />
                    </Grid>
                    :
                    null
                  }
                  {view !== 'tbl' && filterApps(appBasketRender).length > 0
                    ?
                    <Grid item id='paginationContainer-js' container style={{ display: Math.trunc((filterApps(appBasketRender).length - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', paddingLeft: 1, alignItems: 'center' }} >
                      {Math.trunc((filterApps(appBasketRender).length - 1) / 24) > 0
                        ?
                        <Pagination className={classes.newPagination} count={Math.trunc((filterApps(appBasketRender).length - 1) / 24) + 1} page={page} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePage} />
                        :
                        null
                      }

                      <KloBanksChoose kloUser={kloUser} _kloUser={props._kloUser}
                        delta={Math.trunc((filterApps(appBasketRender).length - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : undefined} />


                    </Grid>
                    :
                    null
                  }
                </React.Fragment>
              </TabPanel>

              {/* =============== ПРИЛОЖЕНИЯ ===== */}

              {/* ===== ПРОДУКТЫ =============== */}

              <TabPanel value={valueBasketTab} index={1} style={{ width: '100%', marginTop: 62, minHeight: 12 }}>
                <Grid container spacing={3} style={{ overflowY: 'auto', marginTop: 0 }}>
                  {/* {prodBasket && prodBasket.length > 0 ?
                    prodBasket.map(item => <> </> // TODO: ARH
                    )
                    : 'Пусто'} */}
                  <React.Fragment>
                    {view === 'tile' ?
                      <AllProdsTable
                        setAppProdBasket={setAppProdBasket}
                        cart={true}
                        // cardArr={prodBasketRender}
                        bank={props.bank}
                        IsRu={props.IsRu}
                        cardArr={prodBasketRender.filter((elem, index) => { return index < pageProd * 24 && index >= (pageProd - 1) * 24 })}
                        userCollection={props.userCollection}
                        saveCollection={props.saveCollection}
                        updateArr={updateArr}
                      />
                      :
                      view === 'table' ?
                        <AllProdsTile
                          cart={true}
                          setAppProdBasket={setAppProdBasket}
                          prodBasketChips={prodBasketChips}
                          // cardArr={prodBasketRender}
                          cardArr={prodBasketRender.filter((elem, index) => { return index < pageProd * 24 && index >= (pageProd - 1) * 24 })}
                          bank={props.bank}
                          IsRu={props.IsRu}
                          userCollection={props.userCollection}
                          saveCollection={props.saveCollection}
                          updateArr={updateArr}
                        />
                        :
                        <AllProdsTbl
                          cart={true}
                          setAppProdBasket={setAppProdBasket}
                          prodBasketChips={prodBasketChips}
                          cardArr={prodBasketRender}
                          bank={props.bank}
                          IsRu={props.IsRu}
                          page={pageTbl}
                          setPage={setPageTbl}
                          rowsPerPage={rowsPerPage}
                          setRowsPerPage={setRowsPerPage}
                          userCollection={props.userCollection}
                          saveCollection={props.saveCollection}
                          updateArr={updateArr}
                        />
                    }

                    {
                      view !== 'tbl'
                        ?
                        <Grid item container style={{ display: Math.trunc((prodBasketRender.length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, paddingLeft: 13, alignItems: 'center' }} >
                          <Pagination className={classes.newPagination} id='pagination-js' style={{ 'visible': 'hidden' }} count={Math.trunc((prodBasketRender.length - 1) / 24) + 1} page={pageProd} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageProd} />
                        </Grid>
                        :
                        null
                    }
                    {
                      view !== 'tbl'
                        ?
                        <Grid item id='paginationContainer-js' container style={{ display: Math.trunc((prodBasketRender.length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', paddingLeft: 13, alignItems: 'center' }} >
                          <Pagination className={classes.newPagination} count={Math.trunc((prodBasketRender.length - 1) / 24) + 1} page={pageProd} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageProd} />
                        </Grid>
                        :
                        null
                    }
                  </React.Fragment>
                </Grid>
              </TabPanel>

              {/* =============== ПРОДУКТЫ ===== */}

              {/* ===== ОБЛАЧНЫЕ СЕРВИСЫ =============== */}

              <TabPanel value={valueBasketTab} index={2} style={{ width: '100%', marginTop: 61, minHeight: 13 }}>
                <Grid container spacing={3} style={{ overflowY: 'auto' }}>
                  {view === 'tile' ?
                    <CloudServiceCard
                      cloudBasket={cloudBasket}
                      // cardArr={cloudBasketRender}
                      cardArr={cloudBasketRender.filter((elem, index) => { return index < pageCloud * 24 && index >= (pageCloud - 1) * 24 })}
                      setBasketCloud={setBasketCloud}
                    />
                    :
                    <CloudServiceLineCard
                      // cardArr={cloudBasketRender}
                      cardArr={cloudBasketRender.filter((elem, index) => { return index < pageCloud * 24 && index >= (pageCloud - 1) * 24 })}
                      cloudBasket={cloudBasket}
                      setBasketCloud={setBasketCloud}
                    />
                  }

                  <Grid item container style={{ display: Math.trunc((cloudBasketRender.length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, /*height:32,*/ flexDirection: 'row-reverse', paddingLeft: 13, alignItems: 'center' }} >
                    <Pagination id='pagination-js' style={{ 'visible': 'hidden' }} className={classes.newPagination} count={Math.trunc((cloudBasketRender.length - 1) / 24) + 1} page={pageCloud} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageCloud} />
                  </Grid>
                  <Grid item id='paginationContainer-js' container style={{ display: Math.trunc((cloudBasketRender.length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, flexDirection: 'row-reverse', height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', paddingLeft: 13, alignItems: 'center' }} >
                    <Pagination className={classes.newPagination} count={Math.trunc((cloudBasketRender.length - 1) / 24) + 1} page={pageCloud} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageCloud} />
                  </Grid>
                </Grid>
              </TabPanel>

              {/* =============== ОБЛАЧНЫЕ СЕРВИСЫ ===== */}

              {/* <TabPanel value={valueBasketTab} index={3} style={{ width: '100%' }}>
                  <Grid container direction="column" justify="flex-start" alignItems="flex-start" style={{ outline: '1px solid blue' }}>
                    Item Four
                  </Grid>
                </TabPanel> */}
            </Grid>
          </Grid>
        </React.Fragment>
      </Grid>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbarInfo[0]}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        // message="Приложение доавлено в корзину"
        className={classes.root}
      >

        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          className={classes.postroot}
        >
          <Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
            </svg>
          </Avatar>

          <Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF', width: 'calc(100% - 64px)' }}>{snackbarInfo[1]}</Typography>
        </Grid>
      </Snackbar>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={openSnackbar[0]}
        className={classes.root}
      >
        {openSnackbar[1] === 'clear'
          ?
          <Grid container direction="row" justify="space-between" alignItems="center" className={classes.postrootClear}>
            <Grid item style={{ width: 374 }}>
              <Typography style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
                {translate.Words[`AreYouSureYouWantToClearTheCart${language}`]}?</Typography>
            </Grid>

            <Grid item container className={classes.snackBtnCntr} direction="row">
              <SecondaryButton2 text={translate.Words[`No_${language}`]} height={55} margin={0} width={90} onClick={handleClose} />

              {/* <Grid item style={{ width: 16 }} /> */}

              <PrimaryButton text={translate.Words[`Yes_${language}`]} height={55} width={90} onClick={() => clearBasket()} />
            </Grid>
          </Grid>
          :
          openSnackbar[1] === 'dependencies'
            ?
            <div className={classes.postroot}>
              <Typography style={{ maxWidth: 320, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>{translate.Words[`RemAddDependency_${language}`]}</Typography>

              <Grid item style={{ width: 16 }} />

              <PrimaryButton text={translate.Words[`AddDependencies${language}`]} height={55} onClick={() => addDependency(true)} />

              {/* <SecondaryButton2 text={'Нет'} height={55} margin={'0 16px'} onClick={handleClose} /> */}

              <Grid item style={{ width: 36 }} />

              <IconButton aria-label="delete" size="large" onClick={() => loadwithdependencies(true)} color="secondary" style={{ top: 8, right: 8, position: 'absolute' }}>
                <CloseIcon />
              </IconButton>
            </div>
            :
            ''
        }
      </Snackbar>
    </Grid >
  );
}

const Accordion = withStyles({
  root: {
    background: "transparent",
    border: "none",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: "none"
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: 0,
      background: "transparent"
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "red",
    borderBottom: "none",
    marginBottom: -1,
    minHeight: 0,
    height: 0,
    maxHeight: 0,
    "&$expanded": {
      minHeight: 0
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: 0,
    backgroundColor: "transparent"
  }
}))(MuiAccordionDetails);

const StyledToggleButton = withStyles((theme) => ({
  root: {
    border: "none",
    borderRadius: "16px",
    backgroundColor: "#FFFFFF",
    color: "#24262A",
    padding: "8px 64px",
    textTransform: "none",
    minWidth: 312,
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
  },

  selected: {
    backgroundColor: "transparent !important",
    color: "#24262A",
    textTransform: "none",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
  }
}))(ToggleButton);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.87)',
    color: 'rgba(255, 255, 255, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    borderRadius: '8px',
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 400,
    padding: 12,
    opacity: 0.5,

    '& a': {
      color: 'rgba(255, 255, 255, 0.87)',
    }
  },
}))(Tooltip);

const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    padding: 0,
    paddingTop: 28,
    marginTop: theme.spacing(12),
    // backgroundColor: 'inherit'
  },

  contentOpen: {
    width: `calc(100% - 668px)`,

    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
  },

  contentClose: {
    width: `calc(100% - 218px)`,

    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),

    [theme.breakpoints.down(1366)]: {
      width: '100%'
    }
  },

  container: {
    // margin: '72px auto 0',
    // '&:first-child': {
    //   margin: '0 auto'
    // },
    // [theme.breakpoints.down(696)]: {
    //   maxWidth: 'calc(312px * 1)',
    // },
    // [theme.breakpoints.between(696, 1032)]: {
    //   maxWidth: 'calc(323px * 2)',
    // },
    // [theme.breakpoints.between(1032, 1366)]: {
    //   maxWidth: 'calc(327px * 3)',
    // },
    // [theme.breakpoints.between(1366, 1702)]: {
    //   maxWidth: 'calc(327px * 3)',
    // },
    // [theme.breakpoints.up(1702)]: {
    //   maxWidth: 'calc(330px * 4)',
    // }
  },

  footer: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    padding: '36px 0'
  },

  Header: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '40px',
    lineHeight: '50px',
    color: '#000000'
  },

  Title3: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#24262A'
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  },

  Body11: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#24262A'
  },

  Body2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#24262A'
  },

  cntrChangeView: {
    marginLeft: 8,
    maxWidth: 468,
    justifyContent: 'flex-end',

    [theme.breakpoints.down(1366)]: {
      maxWidth: 296,
    },

    [theme.breakpoints.down(696)]: {
      marginLeft: 0,
      marginTop: 12,
    },
  },

  cntrChangeViewArray: {
    paddingLeft: 12,

    [theme.breakpoints.down(1366)]: {
      display: 'none'
    }
  },

  PrimaryLink: {
    // color: theme.palette.getContrastText(purple[500]), // ERRORBAG 1
    display: 'flex',
    backgroundColor: '#EB505E',
    boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
    borderRadius: '48px',
    textTransform: 'none',
    textDecoration: 'none',
    height: '100%',
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '55px',
    color: '#FFFFFF',                                     //// ERRORBAG 1
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    "&:hover": {
      backgroundColor: '#EB505E',
      textDecoration: 'none',
    }
  },

  postroot: {
    padding: 24,
    alignItems: 'center',
    borderRadius: '16px',
    background: 'rgba(60, 60, 86, 0.9)',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'borderBox',
  },

  postrootClear: {
    padding: '40px 24px',
    alignItems: 'center',
    borderRadius: '16px',
    background: 'rgba(60, 60, 86, 0.9)',
    width: 637,
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'borderBox',

    [theme.breakpoints.down(696)]: {
      width: 319,
    },
  },

  snackBtnCntr: {
    maxWidth: 196,
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.down(696)]: {
      maxWidth: 'unset',
      marginTop: 16,
    },
  },

  filterChip: {
    margin: 6,
    background: '#FFFFFF',
    color: '#8987A2',

    "&:focus": {
      background: '#FFFFFF',
    }
  },

  filterChipSelected: {
    margin: 6,
    background: 'rgb(129, 211, 157)',
    color: '#FFFFFF',

    "&:focus": {
      background: 'rgb(129, 211, 157)',
    }
  },

  filterChipMS: {
    margin: 6,
    background: '#FFFFFF',
    color: '#7D62BA',
    outline: '1px solid rgba(125, 98, 186, 0.3)',

    "&:focus": {
      background: '#FFFFFF',
    }
  },

  filterChipMSSelected: {
    margin: 6,
    background: '#7D62BA',
    color: '#FFFFFF',

    "&:focus": {
      background: '#7D62BA',
    }
  },

  ExtActionsCntr: {
    [theme.breakpoints.down(1032)]: {
      marginTop: 41
    },
  },

  STBtxt: {
    width: 152,
    marginLeft: 9,
  },

  STBsel: {
    width: 152,
    borderBottom: "1px dashed #8987A2",
    color: "#24262A",
    textTransform: "none",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: 9,
  },
  btnFilter: {
    marginLeft: 24,
    backgroundColor: '#FFF',
    borderRadius: '16px',
    '&:focus': {
      borderRadius: '16px'
    }
  },
  filterHeader: {
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#24262A'
  },
  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  FilterActionCntr: {
    padding: 24
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Grid p={3}>
          <Grid>{children}</Grid>
        </Grid>
      )}
    </div>
  );
}

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      // maxWidth: 40,
      width: "100%",
      backgroundColor: "#24262A"
    }
  },

  "& > div.MuiTabs-scroller": {
    width: 'max-content',
  }
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    // color: "#fff",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    lineHeight: '42px',

    "&:focus": {
      opacity: 1
    }
  }
}))((props) => <Tab disableRipple {...props} />);

const FilterButton = withStyles({
  root: {
    width: '100%',
    borderRadius: '48px',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: '18px',
    // padding: 24,
    border: 'none',
    lineHeight: '39px',
    backgroundColor: '#8987A2',
    borderColor: '#0063cc',
    fontFamily: 'Cera CY',
    color: '#FFFFFF',
    fontStyle: 'normal',

    '&:hover': {
      backgroundColor: '#8987A2',
      // borderColor: '#8987A2',
      // boxShadow: 'none',
    },

    // '&:active': {
    //   boxShadow: 'none',
    //   backgroundColor: '#8987A2',
    //   borderColor: '#005cbf',
    // },

    // '&:focus': {
    //   boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    // },
  },
})(Button);